const app = require('./app.js')
const loadingCircle = require('./ui.loadingCircle.js')
const deviceProfile = require('./ui.device.js')
const deviceTimeline = require('./ui.device.timeline.js')
const deviceLocations = require('./ui.device.locations.js')
const infiniteScroll = require('./ui.infiniteScroll.js')
const { Template } = require('./ui.template.js')
const homeTimeline = require('./ui.devices.timeline.js')

class devices extends Template {
    dataType = 'device'

    init() {
        if (app.user.activeDevices) {
            app.webSocket.sendMessage({ type: 'getDevices' })
            loadingCircle.show(document.body)
        } else {
            // document.body.classList.add('no-devices');
        }

        const ui = require('./ui.js')
        new infiniteScroll('tab-content', function (contentId) {
            if (ui.views[contentId] && ui.views[contentId].fetchMore) {
                ui.views[contentId].fetchMore()
            }
        })
    }

    update(views, dataType) {
        loadingCircle.hide()
        app.data.get({ type: 'device' }, (data) => {
            if (!data) {
                // document.body.classList.add('no-devices');
                return
            }
            const template = document.getElementById('device_items')
            const target = document.getElementById('devices')
            target.innerHTML = ''

            for (let device of data) {
                let el = this.inject('device-item' + (device.isOnline ? ' live' : ''), device, target, template)
                el.addEventListener('click', (e) => {
                    let activeBtn = e.target.classList.contains('js-device-item-all-activity')
                    let clkBtnStr = 'div[data-id="' + device.device_id + '"] div.js-device-item-all-activity'
                    let aBtn = document.querySelector(clkBtnStr)
                    if (!(aBtn && window.getComputedStyle(aBtn, null).display === 'flex') || activeBtn) {
                        if (history.state.page && history.state.page == 2) {
                            history.replaceState({ page: 2, action: 'click', target: clkBtnStr }, 'Device', '#/device/' + device.device_id)
                        } else {
                            history.pushState({ page: 2, action: 'click', target: clkBtnStr }, 'Device', '#/device/' + device.device_id)
                        }
                        views['device'] = new deviceProfile(device)
                        views['cast'] = new deviceTimeline(device.device_id)
                        views['location'] = new deviceLocations(device.device_id)
                    }
                })
                el.querySelector('.icon-dots').addEventListener('click', (e) => {
                    e.stopPropagation()
                    e.preventDefault()
                    const menu = el.querySelector('.device-menu')
                    if (menu.classList.contains('hide')) {
                        menu.classList.remove('hide')
                        document.body.onclick = (e) => {
                            if (!e.target.closest('.device-menu')) {
                                console.log(e.target)
                                menu.classList.add('hide')
                                document.body.onclick = null
                            }
                        }
                        //el.classList.add('fadeIn');
                    } else {
                        menu.classList.add('hide')
                        document.body.onclick = null
                    }
                })
                views['homeTimeline-' + device.device_id] = new homeTimeline(device.device_id)
            }
        })
    }
}

module.exports = devices
